/* unplugin-vue-components disabled */
export default {
  inject: ['store', 'schema'],
  computed: {
    doc_title() {
      return this.store.name || 'New Brand'
    },
  },
  methods: {
    getPrintableFields(fields) {
      return fields.filter(item => !['avatar', 'uploader'].includes(item.type))
    },
    transformData(data, type, opt) {
      switch (type) {
        case 'multiselect': {
          const items = data.map(el => opt.predefined?.find(item => item.value === el)?.title || el)
          return $utils.pipes.join(items, {capitalize: true})
        }
        case 'checkgroup': {
          const items = data.map(el => opt.items?.find(item => item.value === el)?.label || el)
          return items.join(' ')
        }
        case 'dropdown':
          return (typeof opt.items === 'string' ? this.store[opt.items] : opt.items)
            ?.find(el => el.value === data)?.title
        case 'urls-list':
          return $utils.pipes.joinUrls(data)
        default: 
          return data
      }
    },
  }
}
